import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  pageName: string;
  onClose: () => void;
}

const SHOW_MS = 2600;
const PIECES = 18;

/** A short "page explored" moment after the last step. Closes itself; any key or click closes it sooner. */
const TourCelebration: React.FC<Props> = ({ pageName, onClose }) => {
  useEffect(() => {
    const timer = window.setTimeout(onClose, SHOW_MS);
    const onKey = () => onClose();
    window.addEventListener('keydown', onKey, true);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('keydown', onKey, true);
    };
  }, [onClose]);

  return createPortal(
    <div className="tour-done" role="status" onClick={onClose}>
      <div className="tour-done__card">
        <div className="tour-done__burst" aria-hidden="true">
          {Array.from({ length: PIECES }, (_, i) => (
            <span key={i} className="tour-done__piece" style={{ '--i': i, '--n': PIECES } as React.CSSProperties} />
          ))}
          <span className="tour-done__check">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" focusable="false">
              <path d="M5 12.5l4.5 4.5L19 7.5" />
            </svg>
          </span>
        </div>
        <p className="tour-done__title">{pageName} explored</p>
        <p className="tour-done__body">Explore is on every page whenever you need a refresher.</p>
      </div>
    </div>,
    document.body,
  );
};

export default TourCelebration;
